import { Table, Tooltip } from "antd";
import React from "react";

function TableDeclarationsUserList(props) {
  const {
    category,
    laborUnionOption,
    laborUnion,
    buildingConventionOutside77,
    workForce,
    userIsAdmin,
    isVerified,
    isActiveFilter,
    data,
    filters,
    totalItems,
    handleTableChange,
    isLoading,
  } = props;

  const withTooltip = (value, bold = false) => {
    const text = typeof value === "object" ? value?.props?.children : value;
    return (
      <Tooltip title={text}>
        <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: bold ? "bold" : undefined }}>
          {text}
        </span>
      </Tooltip>
    );
  };

  const columns = [
    {
      title: "Code Adhérent",
      dataIndex: "membershipCode",
      key: "membershipCode",
      align: "center",
      filteredValue: undefined,
      minWidth: 120,
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      align: "center",
      filteredValue: undefined,
      width: 200,
      ellipsis: true,
      render: (v) => withTooltip(v),
    },
    {
      title: "Raison Sociale",
      dataIndex: "companyName",
      key: "companyName",
      align: "center",
      filteredValue: undefined,
      width: 220,
      ellipsis: true,
      render: (v) => withTooltip(v, true),
    },
    {
      title: "Représentant",
      dataIndex: "representativeName",
      key: "representativeName",
      align: "center",
      filteredValue: undefined,
      width: 160,
      ellipsis: true,
      render: (v) => withTooltip(v),
    },
    {
      title: "Catégorie",
      dataIndex: "membershipCategory",
      key: "membershipCategory",
      align: "center",
      filters: [
        { text: "4 : Etam Cadres & Ouvriers", value: "4" },
        { text: "5 : Adhérent Volontaire", value: "5" },
        { text: "6 : Adhérent CAPEB / - de 10", value: "6" },
      ],
      filteredValue: category || null,
      minWidth: 100,
    },
    {
      title: "Adhérent",
      dataIndex: "laborUnion",
      key: "laborUnion",
      align: "center",
      filters: laborUnionOption,
      filteredValue: laborUnion || null,
      minWidth: 100,
    },
    {
      title: "Conv. Btm. hors 77",
      dataIndex: "buildingConventionOutside77",
      key: "buildingConventionOutside77",
      align: "center",
      filters: [
        { text: "oui", value: "true" },
        { text: "non", value: "false" },
      ],
      filteredValue: buildingConventionOutside77 || null,
      minWidth: 130,
    },
    {
      title: "Effectifs",
      dataIndex: "workForce",
      key: "workForce",
      align: "center",
      filters: [
        { text: "Jusqu'à 10", value: "upTo10" },
        { text: "Plus de 10", value: "moreThan10" },
      ],
      filteredValue: workForce || null,
      minWidth: 90,
    },
    {
      title: "Admin",
      dataIndex: "isAdmin",
      key: "isAdmin",
      align: "center",
      filters: [
        { text: "oui", value: "true" },
        { text: "non", value: "false" },
      ],
      filteredValue: userIsAdmin || null,
      defaultFilteredValue: ["false"],
      minWidth: 80,
    },
    {
      title: "Vérifié",
      dataIndex: "isVerified",
      key: "isVerified",
      align: "center",
      filters: [
        { text: "oui", value: "true" },
        { text: "non", value: "false" },
      ],
      filteredValue: isVerified || null,
      defaultFilteredValue: ["true"],
      minWidth: 80,
    },
    {
      title: "Active",
      dataIndex: "isActiveDisplay",
      key: "isActiveDisplay",
      align: "center",
      filters: [
        { text: "oui", value: "true" },
        { text: "non", value: "false" },
      ],
      filteredValue: isActiveFilter || null,
      minWidth: 80,
    },
    {
      title: "Actions",
      key: "actions",
      dataIndex: "actions",
      align: "center",
      width: 200,
      fixed: "right",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      style={{ flexGrow: 1 }}
      scroll={{ x: "max-content" }}
      rowKey={(row) => row.id}
      pagination={{
        current: filters.page,
        pageSize: filters.pageSize,
        total: totalItems,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      onChange={handleTableChange}
      loading={isLoading}
    />
  );
}

export default TableDeclarationsUserList;
